"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setBranchCookie = exports.isMainBranch = exports.clearBranchCookie = exports.getBranchNameFromCookie = void 0;
const constants_1 = require("@aurora/shared-types/developer/constants");
const universal_cookie_1 = __importDefault(require("universal-cookie"));
function getCookies(cookie) {
    return new universal_cookie_1.default(cookie);
}
/**
 * Gets the switched branch.
 *
 * @param cookie the cookie string only needed for SSR
 */
function getBranchNameFromCookie(cookie) {
    return getCookies(cookie).get(constants_1.BRANCH_NAME_KEY);
}
exports.getBranchNameFromCookie = getBranchNameFromCookie;
/**
 * Function to remove the branch cookie
 */
function clearBranchCookie() {
    getCookies().remove(constants_1.BRANCH_NAME_KEY, { path: '/' });
}
exports.clearBranchCookie = clearBranchCookie;
/**
 * Is this a main branch?
 * @param branchName
 */
function isMainBranch(branchName) {
    return (!branchName ||
        branchName === 'main' ||
        branchName.match(/(dev|qa|stage|bench|demo)-main/) != null);
}
exports.isMainBranch = isMainBranch;
/**
 * Function to store the branch on cookie
 *
 * @param branchName the branch
 */
function setBranchCookie(branchName) {
    if (branchName && !isMainBranch(branchName)) {
        getCookies().set(constants_1.BRANCH_NAME_KEY, branchName, { path: '/' });
    }
    else {
        clearBranchCookie();
    }
}
exports.setBranchCookie = setBranchCookie;
//# sourceMappingURL=SwitchBranchCookieHelper.js.map